import { PapiUser } from '@wix/da-papi-types';
import {
  getCurrentUser,
  getPagingMode,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { getUserById } from '@wix/da-shared-react/pkg/redux/users/selectors';
import { AppState } from '../../types/store';

export const getProfileOwner = (
  state: AppState
): Exclude<AppState['profileOwner'], 'user'> & { user: PapiUser } => ({
  ...state.profileOwner,
  user: getUserById(state, state.profileOwner.user.id),
});

export const getIsWatchingProfileOwner = (state: AppState) =>
  state.profileOwner.isWatching;

export const getProfileOwnerIsWatcher = (state: AppState) =>
  state.profileOwner.isWatcher;

export const getProfileOwnerIsOfferingSubscriptions = (state: AppState) =>
  state.profileOwner.isOfferingSubscriptions;

export const getProfileOwnerStats = (state: AppState) =>
  state.profileOwner.stats;

export const getProfileOwnerStat = (state: AppState, entity) =>
  getProfileOwnerStats(state)[entity];

export const getProfileOwnerTagline = (state: AppState) =>
  state.profileOwner.tagline;

export const getProfileOwnerUser = (state: AppState): PapiUser =>
  getUserById(state, state.profileOwner.user.id);

export const isLoggedIn = state => getCurrentUser(state) !== undefined;

export const isCurrentUserProfileOwner = (state: AppState): boolean => {
  const currentUser = getCurrentUser(state);
  const profileOwner = getProfileOwnerUser(state);
  return !!currentUser && profileOwner.userId === currentUser.userId;
};

export const getIsPagedMode = (state: AppState) =>
  getPagingMode(state) === 'page';
